import React from "react";
import LogNav from "../LoggedNav";
import Tabs from "./Tabs";
import { LiveViewProvider } from "./LiveViewProvider";
import { getAuthData } from "../../../services/authService";
const auth = getAuthData();

const CoursesLive = () => {
  return (
    <>
      <section className="club_Login">
        <div className="page-width">
          <div className="c-live-block gap-block-section">
            <h1 className="c-live--title text-jost-sb-50">
            </h1>

            {/* <LogNav /> */}

            <div className="c-live__wraps">
              <Tabs />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default (props) => (
  <LiveViewProvider>
    <CoursesLive {...props} />
  </LiveViewProvider>
);
